import { CreatePntsDto, formatDate } from '@mi-front/core';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { TruncatedText } from '../../../../../../components/base/TruncatedText';

export const PntSchedulesPreview = ({ data }: { data: CreatePntsDto }) => {
  const { $t } = useIntl();
  return (
    <TableContainer component={Paper} sx={{ mt: 3 }}>
      <Table
        size="small"
        sx={{ minWidth: 650 }}
        aria-label={$t({
          id: 'common.simpleTableAriaLabel',
          defaultMessage: 'Data table',
        })}
      >
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>
              <FormattedMessage id="audit.gipReport.result.date" defaultMessage="Fecha" />
            </TableCell>
            <TableCell>
              <FormattedMessage id="audit.filesUpload.materialId" defaultMessage="ID material" />
            </TableCell>
            <TableCell>
              <FormattedMessage id="common.title" defaultMessage="Título" />
            </TableCell>
            <TableCell>
              <FormattedMessage id="common.text" defaultMessage="Texto" />
            </TableCell>
            <TableCell align="center">
              <FormattedMessage id="common.quantity" defaultMessage="Cantidad" />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((s, index) => (
            <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell>{index + 1}</TableCell>
              <TableCell component="th" scope="row">
                {formatDate(s.date as any, 'DD/MM/YY')}
              </TableCell>
              <TableCell>{s.customId}</TableCell>
              <TableCell>{s.title}</TableCell>
              <TableCell>
                {' '}
                <TruncatedText value={s.dirtyText} />
              </TableCell>
              <TableCell align="center">{s.count}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
